import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Select,
  MenuItem,
  Box,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Paper,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import DashboardLayout from "../../layouts/DashboardLayout";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { companyUserFacilityDetails } from "../../redux/actions";
import CeroTable from "../../components/CeroTable";
import useStyles from "./styles";
import CeroInput from "../../components/CeroInput";
import { getTrackingCycleAssessmentPeriod } from "../../redux/sagas/goalSettings";

export const facilityColumn = [
  {
    columnKey: "country",
    columnId: "country",
    columnHeader: "Country",
  },
  {
    columnKey: "facility",
    columnId: "facility",
    columnHeader: "Facilities",
  },
  {
    columnKey: "users",
    columnId: "users",
    columnHeader: "Total Users",
  },
];

export const UsersListColumns = [
  {
    columnKey: "name",
    columnId: "name",
    columnHeader: "Name",
  },
  {
    columnKey: "email",
    columnId: "email",
    columnHeader: "Email",
  },
];

export const UsersListColumnsWithStatus = [
  {
    columnKey: "name",
    columnId: "name",
    columnHeader: "Name",
  },
  {
    columnKey: "email",
    columnId: "email",
    columnHeader: "Email",
  },
  {
    columnKey: "status",
    columnId: "status",
    columnHeader: "Status",
  },
];

export const SubscriptionListColumnsWithAction = [
  {
    columnKey: "company_name",
    columnId: "company_name",
    columnHeader: "Company Name",
  },
  {
    columnKey: "facility_count",
    columnId: "facility_count",
    columnHeader: "No. of Facilities",
  },
  {
    columnKey: "start_date",
    columnId: "start_date",
    columnHeader: "Subscription Start Date",
  },
  {
    columnKey: "end_date",
    columnId: "end_date",
    columnHeader: "Subscription End Date",
  },
  {
    columnKey: "action",
    columnId: "action",
    columnHeader: "Action",
  },
];

export default function SuperAdminDashboardUserOverviewDetailsPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const location = useLocation();
  const { filter, type, title } = location.state || {};

  const { companyId, status } = useParams();
  const [countryFilter, setCountryFilter] = useState("");
  const [facilityFilter, setFacilityFilter] = useState("");
  const [searchWord, setSearchWord] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedFacility, setSelectedFacility] = useState(null);

  useEffect(() => {
    let statusStr = "active";
    if (status === "inactive") statusStr = "inactive";
    else if (status === "locked") statusStr = "lock";
    else if (status === "disabled") statusStr = "non_active";
    else if (status === "read_only") statusStr = "disable_edit";
    dispatch(companyUserFacilityDetails(companyId, statusStr));
  }, [dispatch]);

  const activeUsersList =
    useSelector((state) => state.superAdmin.companyUserFacilityDetails.data) ||
    {};

  const setFilteredUsersFun = (users) => {
    const modifyUser = users.map((item) => ({
      ...item,
      status: (
        <Typography className={classes[item.status]}>{item.status}</Typography>
      ),
    }));
    setSelectedUsers(modifyUser);
    setFilteredUsers(modifyUser);
  };

  const countryList = Object.keys(activeUsersList);
  let astrIndex = countryList.indexOf("*");
  if (astrIndex !== -1) {
    countryList.splice(astrIndex, 1);
  }

  const facilityList = Object.values(activeUsersList).flatMap((facilitiesObj) =>
    Object.keys(facilitiesObj)
  );
  astrIndex = facilityList.indexOf("*");
  if (astrIndex !== -1) {
    facilityList.splice(astrIndex, 1);
  }

  const renderCompanyTable = () => {
    return (
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table} stickyHeader>
          <TableHead>
            <TableRow>
              {facilityColumn.map((column) => (
                <TableCell
                  key={column.columnId}
                  className={classes.tableHeader}
                >
                  {column.columnHeader}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.keys(activeUsersList).map((row) => {
              const facilityData = Object.keys(activeUsersList[row]);
              const countryLength = facilityData.length;
              const firstIndex = facilityData?.[0];

              const shouldShowRow =
                (!countryFilter || row === countryFilter) &&
                (!facilityFilter || facilityData.includes(facilityFilter));

              if (!shouldShowRow) return null;

              return (
                <React.Fragment key={row}>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      rowSpan={countryLength}
                    >
                      {row}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      {firstIndex}
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      onClick={() => {
                        setFilteredUsersFun(activeUsersList[row][firstIndex]);
                        setSelectedFacility(firstIndex);
                      }}
                    >
                      {activeUsersList[row][firstIndex].length}
                    </TableCell>
                  </TableRow>

                  {facilityData.slice(1).map((fac) => (
                    <TableRow key={fac}>
                      <TableCell className={classes.tableCell}>{fac}</TableCell>
                      <TableCell
                        className={classes.tableCell}
                        onClick={() => {
                          setFilteredUsersFun(activeUsersList[row][fac]);
                          setSelectedFacility(fac);
                        }}
                      >
                        {activeUsersList[row][fac].length}
                      </TableCell>
                    </TableRow>
                  ))}
                </React.Fragment>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const filterData = (searchPattern, filterType) => {
    const lowerPattern = searchPattern.toLowerCase();
    let userTmp = [...selectedUsers];

    const applyNameFilter = (list, keyWord = null) =>
      list.filter((item) =>
        item.name.toLowerCase().includes(keyWord ? keyWord : lowerPattern)
      );

    const applyStatusFilter = (list, keyWord = null) =>
      list.filter((item) =>
        item.status.toLowerCase().includes(keyWord ? keyWord : lowerPattern)
      );

    if (filterType === "search") {
      setSearchWord(searchPattern);
      if (searchPattern) {
        userTmp = applyNameFilter(userTmp);
        if (statusFilter) userTmp = applyStatusFilter(userTmp, statusFilter);
      }
    } else {
      setStatusFilter(searchPattern);
      if (searchPattern) {
        userTmp = applyStatusFilter(userTmp);
        if (searchWord) userTmp = applyNameFilter(userTmp, searchWord);
      }
    }

    setFilteredUsers(userTmp);
  };

  const baseColumns = filter.includes("total")
    ? UsersListColumnsWithStatus
    : UsersListColumns;

  // Clone and add custom column at the beginning if fac is "*"
  const columnsToUse =
    selectedFacility === "*"
      ? [
          {
            columnKey: "role",
            columnId: "role",
            columnHeader: "role",
          },
          ...baseColumns,
        ]
      : baseColumns;
  return (
    <DashboardLayout>
      <Container maxWidth={false} sx={{ py: 4, px: 5 }}>
        {/* Flex wrapper */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          mb={3}
        >
          <Box>
            {!selectedFacility ? (
              <>
                <Select
                  value={countryFilter}
                  onChange={(e) => setCountryFilter(e.target.value)}
                  displayEmpty
                  size="small"
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    mb: 4,
                    width: "220px",
                    marginRight: "10px",
                  }}
                >
                  <MenuItem value="">Country</MenuItem>
                  {countryList.map((c) => (
                    <MenuItem key={c} value={c}>
                      {c}
                    </MenuItem>
                  ))}
                </Select>
                <Select
                  value={facilityFilter}
                  onChange={(e) => setFacilityFilter(e.target.value)}
                  displayEmpty
                  size="small"
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    mb: 4,
                    width: "220px",
                  }}
                >
                  <MenuItem value="">Facility</MenuItem>
                  {facilityList.map((c) => (
                    <MenuItem key={c} value={c}>
                      {c}
                    </MenuItem>
                  ))}
                </Select>
              </>
            ) : (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={3}
              >
                {filter.includes("total") && (
                  <Select
                    value={statusFilter}
                    onChange={(e) => filterData(e.target.value, "status")}
                    displayEmpty
                    size="small"
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      mb: 4,
                      width: "220px",
                      marginRight: "10px",
                    }}
                  >
                    <MenuItem value="">Status</MenuItem>
                    {["active", "inactive", "read only", "disabled"].map(
                      (c) => (
                        <MenuItem key={c} value={c}>
                          {c}
                        </MenuItem>
                      )
                    )}
                  </Select>
                )}
                <CeroInput
                  value={searchWord}
                  onChange={(e) => filterData(e.target.value, "search")}
                  displayEmpty
                  size="small"
                  classes={{
                    container: classes.searchBox,
                    input: classes.inputBox,
                  }}
                  label={<span>Search</span>}
                />
              </Box>
            )}
            <Typography
              variant="h6"
              fontWeight={600}
              mb={1}
              sx={{ textAlign: "left" }}
            >
              {`${title}  ${selectedFacility ? " > " + selectedFacility : ""}`}
            </Typography>
          </Box>

          {/* Back button right */}
          <Button
            variant="outlined"
            onClick={() => {
              if (selectedUsers.length) {
                setSelectedUsers([]);
                setSearchWord("");
                setStatusFilter("");
              } else navigate(`/dashboard/details/${type}/${filter}`);
              setSelectedFacility("");
            }}
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              px: 4,
              borderColor: "#7B2D43",
              color: "#7B2D43",
              fontWeight: 500,
              "&:hover": {
                borderColor: "#7B2D43",
                backgroundColor: "transparent",
              },
            }}
            startIcon={<ArrowBack />}
          >
            Back
          </Button>
        </Box>
        {selectedUsers.length ? (
          <Container className={classes.tableContainerCero}>
            <CeroTable
              columns={columnsToUse}
              hasMore={false}
              loading={false}
              data={filteredUsers}
              onSelectRow={() => {
                console.log("");
              }}
            />
          </Container>
        ) : (
          renderCompanyTable()
        )}
      </Container>
    </DashboardLayout>
  );
}
